
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["CommonDecrypt"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "e495d03829e7f9f45920.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			